<template lang="pug">
  .row.report-template.report-template-editing
    .col-md-9.contents
      .row
        label.col-md-3(for="name") Template Name:
        .col-md-9
          input.col-md-12.title#name(type="text" v-model="template.name" placeholder="Name")

        label.col-md-3(for="name") Template Short Name:
        .col-md-9
          input.col-md-12.title_short#name_short(type="text" v-model="template.name_short" placeholder="Name")

        label.col-md-3(for="tod") Day of Week
        .col-md-9
          vue-multiselect(:value="dow" @input="setDays"
            :options="days" :multiple="true"
            :close-on-select="false" :clear-on-select="false"
            :hide-selected="true" :preserve-search="true"
            placeholder="Day")
            template(slot="tag" scope="props")
              span.custom__tag
                span {{ props.option }}
                span.custom__remove(@click="props.remove(props.option)") ❌
        label.col-md-3(for="tod") Time Of Day
        .col-md-9
          vue-multiselect(:value="tod" @input="setHours"
            :options="hours" :multiple="true"
            :close-on-select="false" :clear-on-select="false"
            :hide-selected="true" :preserve-search="true"
            placeholder="Hour")
            template(slot="tag" scope="props")
              span.custom__tag
                span {{ props.option }}
                span.custom__remove(@click="props.remove(props.option)") ❌

        .col-md-12.field.intro
          label.col-md-12(for="intro") Intro:
          textarea.form-control.col-md-12(rows="10" v-model="template.intro" placeholder="Intro Text")

        .col-md-12.field.outro
          label.col-md-12(for="outro") Outro:
          textarea.form-control.col-md-12(rows="10" v-model="template.close" placeholder="Outro Text")
      .row
        label.col-md-3.images
          div Images:
          b-button(@click.stop.prevent="toggleImagesExpanded" size="sm") Toggle Details
        draggable.col-md-9.row.images(v-model="images" v-if='imagesExpanded')
          .row.image(v-for="image in images")
            .col-md-12.field
              label.col-md-2(for="title") Title:
              input.col-md-10.title#title(type="text" v-model="image.title" placeholder="Title")
            .col-md-12.field
              label.col-md-2(for="text") Text:
              textarea.form-control.col-md-10.text#text(rows="5" v-model="image.text" placeholder="Text")
            .col-md-12.field
              label.col-md-2(for="url") URL:
              input.col-md-10.url#url(type="text" v-model="image.url" placeholder="URL")
            .col-md-12.field
              label.col-md-2(for="timeout") timeout:
              input.col-md-10.url#delay(type="number" v-model="image.timeout"
                                        min=1 max=180 placeholder="Timeout")
            .col-md-12.field
              label.col-md-2(for="width") width:
              input.col-md-10.url#delay(type="number" v-model="image.width"
                                        min=1 max=180 placeholder="Width")
            .col-md-12.field
              label.col-md-2(for="height") height:
              input.col-md-10.url#delay(type="number" v-model="image.height"
                                        min=1 max=180 placeholder="Height")
            .col-md-4.push-md-8.actions
              b-button(@click.stop.prevent="onDeleteImage(image)" size="sm" variant="danger") Delete
        draggable.col-md-9.row.images(v-model="images" v-else)
          .row.image.collapsed.col-md-12(v-for="image in images")
            strong.col-md-12 {{ image.title }}
        footer.row.col-md-12
          b-button(@click.stop.prevent="onAddImage" size="sm" variant="success") Add Image
    .col-md-3.actions
      b-button(@click.stop.prevent="onCancel" size="sm") Cancel
      b-button(@click.stop.prevent="onSave" size="sm" variant="success") Save
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import vueMultiselect from 'vue-multiselect'
import draggable from 'vuedraggable'

export default {
  name: 'report-template-form',
  components: { vueMultiselect, draggable },
  props: {
    template: {}
  },
  data () {
    return {
      imagesExpanded: true,
      hours: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
        13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
      ],
      days: [ 1, 2, 3, 4, 5, 6, 7 ]
    }
  },
  computed: {
    ...mapState(['reportTemplates']),
    ...mapGetters(['reportTemplateIDs']),
    images: {
      get () {
        return this.template.data.images
      },
      set (images) {
        this.template.data.images = images
      }
    },
    dow () {
      if (!this.template) {
        return []
      }
      if (typeof this.template.dow === 'string') {
        return this.template.dow.split(',').map(f => parseInt(f, 10))
      }
      return this.template.dow
    },
    tod () {
      if (!this.template) {
        return []
      }
      if (typeof this.template.tod === 'string') {
        return this.template.tod.split(',').map(f => parseInt(f, 10))
      }
      return this.template.tod
    }
  },
  methods: {
    ...mapActions(['addReport', 'updateReport']),
    ...mapActions(['deleteReportTemplate', 'addReportTemplate', 'updateReportTemplate']),
    onCancel () {
      this.$emit('cancel')
    },
    onSave () {
      this.editing = false
      if (this.template.id) {
        this.updateReportTemplate(this.template)
      } else {
        this.addReportTemplate(this.template)
      }
      this.$emit('save')
    },
    toggleImagesExpanded () {
      this.imagesExpanded = !this.imagesExpanded
    },
    setDays (days) {
      this.template.dow = days
      this.$forceUpdate()
    },
    setHours (hours) {
      this.template.tod = hours
      this.$forceUpdate()
    },
    onDeleteImage (image) {
      let images = this.template.data.images
      let index = images.indexOf(image)
      if (index > -1) {
        images.splice(index, 1)
      }
    },
    onAddImage () {
      this.template.data.images.push({})
    },
    onDelete () {
      if (!confirm(`
Are you sure you want to delete this template?
Reports using this template will also be deleted
      `)) {
        return
      }
      this.deleteReportTemplate(this.template)
    }
  }
}

</script>

<style lang="stylus" scoped>

.report-template {
  margin-top: .5em
  margin-bottom: .5em

  header {
    font-weight: bold
  }

  .actions {
    text-align: right
    button {
      margin-left: .5em
    }
  }

  .form-control {
    display: inline-block
  }

  .images {
    margin-top: .5em

    .image {
      margin-bottom: 2em

      &.collapsed {
        cursor: pointer
        padding: 1em 0
        margin: .5em 0
        border: 1px solid #ccc
      }
    }

    .url {
      color: gray
    }

    header {
      font-weight: bold
    }
  }

  &.report-template-editing {
    .images {
      footer {
        margin: .5em auto
      }
    }

    label {
      font-weight: bold
    }

    .url {
      margin-left: 0
      color: black
      font-size: 1em
    }
  }
}

</style>




// WEBPACK FOOTER //
// report-template-form.vue?60b7b6be